<template>
  <section class="py-4">
    <v-container>
      <v-row align="center" justify="center">
        <v-col cols="12" xl="6">
          <div class="text-center">
            <h3 class="text-h4 font-weight-light mb-3">What are Reward Points?</h3>
            <h4 class="text-body-1 mb-6">
              Reward points are a new 100ASA feature. It's our way of saying
              "thank you" every time you spend time on our platform. You can use
              Reward Points to redeem unique products from the
              <nuxt-link to="/rewards">Rewards</nuxt-link> page.<br />For example,
              you can use them to pay for your membership, professional
              critiques, amazon gift cards and much more.
            </h4>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'TokensInfo'
}
</script>
